export const css = {
    root: 'KkwScWPP',
    grouphead: '_2c8uBOfw',
    actions: '_3n7jnSb9',
    group: 'Nwc4g7l4',
    progress: '_1sfDDEor',
    toc: '_2jJQxHiE',
    resource: '_12-TKVq6',
    competencyConnection: '_2QtUlpCh',
    topicBlock: '_1NwBlPyD',
    titleBlock: 'jlM0Uh07',
    title: '_2D2Db9DC',
    close: '_3aybzIKs',
    deck: '_2PZUU-aK',
    refTitleBlock: '_1sSC6S3I',
    complete: 'OPDOtbCH',
    incomplete: '_1ziJCo5E',
    refTitle: '_1T-qg2Tv',
    fragment: '_1hHmgXaJ',
    readButton: '_39jHl4g2',
    legend: '_3sDAJPrp',
    legendText: '_3FkQ52KF',
    action: 'glFIrjm_',
    actionIcon: '_7dOa5iJb',
    actionText: 'HYRsYhfr',
    activitycontent: 'yXIIhelJ',
    videolink: '_3s7xa53D',
    cialink: '_10WdM9c9',
    ciacontent: '_22bzwBeO',
    resourcecontent: '_3rVoq8Te',
    resourcelink: '_3C7tGHtH',
    scorePill: '_1KwNbdHM',
    topicAudio: '_14yd9l_u',
    ' _key': 'afcpe-theme/afcpe/micro/book-widgets/topicgroup'
};
export default css;
